import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as labelConfigs from '../../configs/labelConfigs';
import * as staticConfigs from '../../configs/staticConfigs';
import {URL_IMG,LOGO_URL} from '../../configs/urlConfigs'; 
import { setStorage } from '../../utils/browserStorage'; 
import {emailVerifyAction} from '../../actions/authenticationActions';

class EmailVerifyComponent extends Component {
    constructor(props){
        super();

        this.state = { 
            userId: '',
            userToken: '',
            userGroupId: 0,
            statusMessage: '',
            statusMessageNext: '',
            userActivated: 0, 
            respStatusCode: 0,
            showLogin: 0 
        }

        this.gotoLogin = this.gotoLogin.bind(this); 
    } 

    componentDidUpdate() {
        if (this.state.userActivated > 0) {
            this.props.history.push(staticConfigs.ROUTE_RESET_PASSWORD); 
        }
        this.setState(); 
    }



    componentDidMount() {
        document.title = labelConfigs.LBL_APP_NAME+' : Email Verification';
        document.body.classList.add('login'); 

        // let paramStr = this.props.location.search; 
        // http://localhost:8000/activate-user?uid=Mw&token=5f5-800f7f9d978184cce486
        const searchParams = new URLSearchParams(this.props.location.search);
     
        let uIdVal = searchParams.get("userId"); 
        let tokenVal = searchParams.get("token"); 
        let expTime = searchParams.get("time"); 
        // if(paramStr!=='')  uIdVal = paramStr.replace('?userId=', ''); 
        // console.log(paramStr+' : '+uIdVal+' : '+this.props.location.search); 
        // if(paramStr==='' || paramStr.indexOf('?userId=')===-1 || uIdVal==='') {
        if(!uIdVal || !tokenVal) {
            this.setState({statusMessage: 'Invalid parameters.... Email verification failed!', statusMessageNext: ''}); 
        }
        else {
            this.setState({userId:uIdVal, userToken:tokenVal, statusMessage: 'Verification in progress....', statusMessageNext: ''}); 
            this.props.dispatch(emailVerifyAction({"userId":uIdVal,"userToken":tokenVal,"time":expTime}));
        }
    }

    gotoLogin() {
        if (this.state.userGroupId===parseInt(staticConfigs.LOGIN_SUPER_ADMIN_GROUP,10)) {
            this.props.history.push(staticConfigs.LOGIN_ROUTE_SUPER_ADMIN); 
        }
        else if (this.state.userGroupId===parseInt(staticConfigs.LOGIN_AFFILIATE_GROUP,10)) {
            this.props.history.push(staticConfigs.LOGIN_ROUTE_AFFILIATE); 
        }
        else if (this.state.userGroupId===parseInt(staticConfigs.LOGIN_OMNU_AFFILIATE_GROUP,10)) {
            this.props.history.push(staticConfigs.LOGIN_ROUTE_CLIENT); 
        }
        else if (this.state.userGroupId===parseInt(staticConfigs.LOGIN_CLIENT_GROUP,10)) {
            this.props.history.push(staticConfigs.LOGIN_ROUTE_CLIENT); 
        }
        else if (this.state.userGroupId===parseInt(staticConfigs.LOGIN_CREW_GROUP,10)) {
            this.props.history.push(staticConfigs.LOGIN_ROUTE_CREW); 
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps)  {   
        if (nextProps.response.emailVerify.hasOwnProperty('response')) {
            let emailVerifyResponse = nextProps.response.emailVerify.response; 
            // 408 Link Expired
            // 404 User not found
            // 401 Invalid token
            // 208 User email already verified

            if (emailVerifyResponse.status===200) {
                let uId     = emailVerifyResponse.data.user_id;
                let groupId = emailVerifyResponse.data.group_id;
                let uToken  = emailVerifyResponse.data.token; 
                // NEED TO DO - IF STATUS IS 200 AND TOKEN IS EMPTY, THEN SHOW EMAI  VERIFIED MESSAGE AND REDIECT TO LOGIN PAGE 
                this.setState({userId: uId, userGroupId: groupId, userToken: uToken, userActivated: 1});
                setStorage('user_id', uId);
                setStorage('user_token', uToken);
                setStorage('user_group', groupId);
                return { 
                    userActivated: 1
                }; 
            } 
            else if (emailVerifyResponse.status===208) { 
                let groupId  = emailVerifyResponse.data.group_id;
                let userMessage  = emailVerifyResponse.data.message;

                this.setState({userGroupId: groupId, showLogin: 1, statusMessage: userMessage, statusMessageNext: ''}); 
                return {
                    userActivated: 0
                };
            } 
            else  if (emailVerifyResponse.status===408) {
                this.setState({statusMessage: 'Sorry, Email verification link expired, ', statusMessageNext: 'Please contact Administrator'});
                return {
                    userActivated: 0
                };
            }
            else  if (emailVerifyResponse.status===401) {
                this.setState({statusMessage: 'Sorry, Email verification failed due to invalid link, ', statusMessageNext: 'Please contact Administrator'});
                return {
                    userActivated: 0
                };
            } else  {
                this.setState({statusMessage: 'Sorry, Email verification failed, ', statusMessageNext: 'Please contact Administrator'});
                return {
                    userActivated: 0
                };
            }
        }else{
            return {
            };
        }  
    }


    render() {
        // const { location } = this.props; 
        //console.log(location.pathname+' ::: '+staticConfigs.ROUTE_VERIFY_EMAIL); 
        
        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="login-logo">                    
                                <Link to="#"><img src={LOGO_URL} alt="Logo" className="logo-width" /></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="login-box">
                    <div className="row">
                            <form className="col-md-12" >
                                <div className="left-align"><h5>Email verification</h5> <hr></hr>       </div>
                                <div>&nbsp;</div>
                                <div>
                                    <div className="form-group">
                                        <div className="text-left text-red text-16">{this.state.statusMessage}</div>
                                        <div className="text-left text-red text-16">{this.state.statusMessageNext}</div>
                                        {this.state.showLogin > 0 && <div onClick={this.gotoLogin} className="text-left text-16 linkStyle">Click here to Login</div> }
                                    </div>
                                    
                                </div>
                                <div> <div className="form-group"> &nbsp; </div>  </div>
                                <div>
                                    <div className="form-group">
                                    {/* <button type="submit" className="btn btn-primary float-right">Login</button> */}
                                    </div>
                                </div>
                            </form>
                    </div>
                </div>
            </React.Fragment>            
        )
    }
}

const mapStateToProps = (response) => ({response});
export default withRouter(connect(mapStateToProps)(EmailVerifyComponent));
// export default EmailVerifyComponent;

